var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white py-8 px-3" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.$apollo.queries.activities.loading,
            hasData: !!_vm.activities,
          },
        },
        [
          _vm.activities.length
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-row flex-wrap gap-4 justify-center",
                    },
                    _vm._l(_vm.activities, function (activity) {
                      return _c("ContractorActivityCard", {
                        key: activity.id,
                        attrs: {
                          activity: activity,
                          project: _vm.project,
                          currentUserId: _vm.currentUserId,
                          currentUserRole: _vm.currentUserRole,
                        },
                        on: {
                          updated: function ($event) {
                            return _vm.$apollo.queries.activities.refetch()
                          },
                        },
                      })
                    }),
                    1
                  ),
                  _c("CardPagination", {
                    attrs: { config: _vm.paginationConfig },
                    on: {
                      "update:config": function ($event) {
                        _vm.paginationConfig = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _c("EmptyListPlaceholder", {
                attrs: {
                  title: "There are no visits",
                  subtitle: _vm.emptyListSubtitle,
                },
                scopedSlots: _vm._u([
                  {
                    key: "image",
                    fn: function () {
                      return [_c("EmptyListImageContractors")]
                    },
                    proxy: true,
                  },
                ]),
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }